import React from 'react';

export function FabSpendSheet({ 
    showFAB, 
    setShowFAB, 
    fabBudget, 
    setFabBudget, 
    fabCategory, 
    setFabCategory, 
    fabAmt, 
    setFabAmt, 
    fabNote, 
    setFabNote, 
    handleFABSubmit,
    fabBudgetConfig
}) {
    if (!showFAB) return null;

    return (
        <div className="fab-sheet-overlay" onClick={() => setShowFAB(false)}>
            <div className="fab-sheet" onClick={e => e.stopPropagation()}>
                <div className="fab-sheet-handle" />
                <div className="fab-sheet-title">Log Spend</div>

                <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' }}>Budget Cycle</div>
                <div className="fab-budget-selector">
                    {Object.entries(fabBudgetConfig).map(([key, cfg]) => (
                        <button
                            key={key}
                            className={`fab-budget-btn ${fabBudget === key ? 'selected' : ''}`}
                            onClick={() => { setFabBudget(key); setFabCategory(null); }}
                        >
                            {cfg.label}
                        </button>
                    ))}
                </div>

                {fabBudget && (() => {
                    const cfg = fabBudgetConfig[fabBudget];
                    const activeItems = cfg.items.filter(i => i.enabled && (i.amount || 0) > 0);
                    return activeItems.length > 0 ? (
                        <>
                            <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '8px' }}>Category</div>
                            <div className="fab-category-selector">
                                {activeItems.map(item => {
                                    const remaining = (item.amount || 0) - (item.actualSpent || 0);
                                    return (
                                        <button
                                            key={item.id}
                                            className={`fab-category-btn ${fabCategory === item.id ? 'selected' : ''}`}
                                            onClick={() => setFabCategory(item.id)}
                                        >
                                            <span>{item.category}</span>
                                            <span className="fab-category-remaining">
                                                {remaining >= 0
                                                    ? `${cfg.symbol}${remaining.toLocaleString()} left`
                                                    : <span style={{ color: 'var(--danger)' }}>{cfg.symbol}${Math.abs(remaining).toLocaleString()} over</span>
                                                }
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </>
                    ) : (
                        <div style={{ fontSize: '13px', color: 'var(--text-tertiary)', padding: '8px 0 12px' }}>No active items in this cycle.</div>
                    );
                })()}

                {fabBudget && fabCategory && (
                    <>
                        <div className="fab-amount-row">
                            <input
                                type="number"
                                className="fab-amt-input"
                                value={fabAmt}
                                onChange={e => setFabAmt(e.target.value)}
                                placeholder={`${fabBudgetConfig[fabBudget].symbol} Amount`}
                                inputMode="decimal"
                                autoFocus
                                onKeyDown={e => e.key === 'Enter' && handleFABSubmit()}
                            />
                        </div>
                        <input
                            type="text"
                            className="fab-note-input"
                            value={fabNote}
                            onChange={e => setFabNote(e.target.value)}
                            placeholder="Note (optional, e.g. NTUC, petrol)"
                            maxLength={60}
                            onKeyDown={e => e.key === 'Enter' && handleFABSubmit()}
                        />
                        <button
                            className="fab-confirm-btn"
                            onClick={handleFABSubmit}
                            disabled={!fabAmt || parseFloat(fabAmt) <= 0}
                        >
                            ✓ Log Spend
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
